import type { AxiosInstance } from 'axios';

export const curry1 = <T extends any[] = any[], R = any>(
  fn: (instance: AxiosInstance, ...rest: T) => R
) => {
  return (instance: AxiosInstance) => {
    return (...rest: T) => {
      return fn(instance, ...rest);
    };
  };
};

export const parsePageParam = (value: string | number): number | undefined => {
  if (typeof value === 'number') {
    return value;
  }

  const page = parseInt(value);

  if (!isNaN(page)) {
    return page;
  }
};
